<template>
  <button @click="callback(competence)" class="button big-button niveau-de-diff--relative">
    <span>{{ competence.valeur }}</span>
    <repeater class="niveau-de-diff--absolute" :courant="competence.niveau" maximum="4" li-css-custom="niveau"/>
  </button>
</template>

<script>
import Repeater from './Repeater';

export default {
  name: 'ChoixCompetence',
  components: {Repeater},
  props: ['competence', 'callback']
}
</script>

<style scoped>
@media (min-width: 932px) {
  #appcompetences--widget .liste-competences--flex .big-button {
    width: 48%;
    margin: 1%;
  }
}

.niveau-de-diff--relative {
  position: relative;
}

.niveau-de-diff--absolute.niveau-de-diff--absolute {
  width: 5rem;
  position: absolute;
  bottom: 0;
  left: 0;
  margin-bottom: 0.4em;
}
</style>